var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_154_2277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4062 0.398499H1.59375C1.28035 0.395309 0.978492 0.516575 0.7544 0.735687C0.530308 0.954799 0.402291 1.25386 0.398438 1.56725V15.4355C0.402987 15.7485 0.531311 16.0468 0.755327 16.2654C0.979343 16.4839 1.28081 16.6048 1.59375 16.6016H15.4062C15.7197 16.6041 16.0213 16.4824 16.2453 16.2632C16.4693 16.0439 16.5974 15.7449 16.6016 15.4315V1.56326C16.596 1.25079 16.4673 0.95316 16.2435 0.735053C16.0196 0.516947 15.7188 0.395999 15.4062 0.398499Z",
    fill: "#0076B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.79702 6.47168H5.20226V14.2107H2.79702V6.47168ZM4.00031 2.62012C4.27617 2.62012 4.54585 2.70194 4.7752 2.85523C5.00456 3.00852 5.1833 3.2264 5.28881 3.48129C5.39432 3.73619 5.42186 4.01665 5.36794 4.2872C5.31403 4.55775 5.18108 4.80622 4.98592 5.0012C4.79076 5.19618 4.54215 5.32889 4.27155 5.38255C4.00095 5.4362 3.72051 5.4084 3.46572 5.30265C3.21093 5.19689 2.99322 5.01795 2.84015 4.78844C2.68708 4.55894 2.60551 4.28919 2.60577 4.01332C2.60613 3.6437 2.75321 3.28933 3.01469 3.0281C3.27618 2.76686 3.63068 2.62012 4.00031 2.62012ZM6.71101 6.47168H9.01663V7.53418H9.04851C9.36992 6.9259 10.1535 6.28441 11.3236 6.28441C13.7594 6.2791 14.2109 7.88215 14.2109 9.96066V14.2107H11.8057V10.4454C11.8057 9.54895 11.7898 8.3948 10.5559 8.3948C9.3221 8.3948 9.11226 9.3723 9.11226 10.387V14.2107H6.71101V6.47168Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_154_2277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIinkedIn);
export default __webpack_public_path__ + "static/media/IinkedIn.771221d45cef3462f8830c0c3a589290.svg";
export { ForwardRef as ReactComponent };